import { RouteRecordRaw } from 'vue-router';

import {
  useBulkImportStore,
  useRootStore,
  useSystemSettingStore,
} from '@/store';

/**
 * 一括登録関連
 */
export const bulkImportRoutes: Array<RouteRecordRaw> = [
  {
    name: 'BulkImport',
    component: () => import('@/components/pages/bulk-import/index.vue'),
    path: '/bulk-import',
    meta: {
      title: '一括登録履歴',
      requiredAuthority: 'MASTER_UPLOADS',
    },
  },
  {
    name: 'BulkImportAdd',
    component: () => import('@/components/pages/bulk-import/add/index.vue'),
    path: '/bulk-import/add',
    meta: {
      title: '一括登録予約',
      requiredAuthority: 'MASTER_UPLOADS',
    },
    beforeEnter: async (_, __, next) => {
      await useSystemSettingStore().getSystemSetting();
      useBulkImportStore().$reset();
      useRootStore().$reset();
      next();
    },
  },

];
